<template>
  <img :src="src" :alt="alt" @error="onError" />
</template>

<script>
export default {
  name: 'SecureImage',
  props: {
    attachment: { type: Object, required: true },
    alt: { type: String, default: '' },
  },
  data() {
    return { src: '' };
  },
  mounted() {
    this.loadBlob();
  },
  methods: {
    resolveUrl(path) {
      if (!path) return '';
      const s = String(path);
      const m = s.match(/\/media\/.*$/);
      if (m) return m[0];
      if (s.startsWith('http://') || s.startsWith('https://')) return s;
      const normalized = s.startsWith('/') ? s : `/${s}`;
      if (normalized.startsWith('/media') || normalized.startsWith('/api')) return normalized;
      // 使用当前页面的origin，不硬编码端口
      return `${window.location.origin}${normalized}`;
    },
    async loadBlob() {
      // 直接使用media URL加载图片，不通过API
      const url = this.attachment && (this.attachment.url || this.attachment.image_url);
      this.src = this.resolveUrl(url);
    },
    onError() {
      this.src = this.resolveUrl(this.attachment && this.attachment.url);
    },
  },
};
</script>
